<template>
  <material-card
    color="primary"
    icon="mdi-api"
  >
    <template #title>
      API Token
    </template>
    <v-card-text>
      <p>Click the button below to generate a new API Token. The token will be valid for 1 year and will only be shown once. Creating a new token will invalidate any existing token.</p>
      <p v-if="user.api_expires !== null"> Existing token will expire on {{ getUTCString(user.api_expires) }}</p>
      <form
        @submit.prevent="generateToken"
      >
        <v-btn
          type="submit"
          class="mt-2"
          block
          color="primary"
          value="generate token"
        >
          Generate Token
        </v-btn>
        <v-alert
          v-if="error"
          class="mt-4"
          type="error"
          dismissible
        >
          {{ error }}
        </v-alert>
        <v-alert
          v-if="currentToken"
          class="mt-4 overflow-x-auto"
          type="success"
          dismissible
        >
          {{ currentToken }}
        </v-alert>
      </form>
    </v-card-text>
  </material-card>
</template>
<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import { sync } from 'vuex-pathify'
  import getEnv from '@/util/env'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'ApiTokenCard',
    data () {
      return {
        currentToken: '',
        error: ''
      }
    },
    computed: {
      ...sync('user', [
        'user',
      ]),
    },
    methods: {
      generateToken() {
        axios.post(
          `${host}/v2/users/api-token`,
          {},
          {
            headers: authHeader(),
          },
        )
        .then((response) => {
          this.currentToken = response.data.token
          var d = new Date();
          this.user.api_expires = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
        })
        .catch((err) => {
          this.error = err
        })
      },
      getUTCString: function (datetime) {
        const d = new Date(datetime)
        return d.toUTCString()
      }
    }
  }
</script>
